(ns frontend.view.components.form.components.form-attachments
  (:require [frontend.view.components.attachments :as attachments]
            [frontend.utils :refer [prevent-default-event!]]
            [frontend.bootstrap.components :as rbs]))

(defn view
  [{:keys [label size value wrapper field control-id accounts guest-accounts]}]
  (let [attachments (:attachments field)]
    [:div
     {:class-name "px-4"}
     [rbs/Form
      {:on-submit prevent-default-event!}
      [rbs/FormGroup
       [attachments/attachments-view {:target      value
                                      :attachments attachments
                                      :accounts    (->> accounts
                                                        (concat guest-accounts)
                                                        distinct)}]]]]))
